var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-jumbotron',{attrs:{"gradient":"to top, #0099cc, #033863","dark":""}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('h3',{staticClass:"display-3"},[_vm._v("Not found")]),_c('h4',{staticClass:"display-1"},[_vm._v("Please verify your url or contact the support if the error persists")])])],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76a0bad4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = null
// module chunks = 